// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__nPdr+"};